const OnlineSaleStatus = {
    /** Published and available for online purchase */
    Live: 'Live',
    /** Disable online sale for this item */
    Off: 'Off',
    /** Locked because the item is mid-purchase */
    Reserved: 'Reserved',
    /** Cannot go live yet (missing fields, validation pending) */
    NotReady: 'NotReady',
};
/**
 * Returns true when the item is currently live for online sale. Single source
 * of truth used by the InventoryItem class's `isMarkedForOnlineSale` getter
 * and by every consumer that reads from a search record or listing interface.
 */
function isOnlineSaleLive(item) {
    return item.onlineSale?.status === OnlineSaleStatus.Live;
}

export { OnlineSaleStatus, isOnlineSaleLive };
//# sourceMappingURL=OnlineSale.js.map
